import React from 'react';
import {useProductAttributes} from "../../../state";
import {FormattedMessage, useIntl} from 'react-intl';
import {useTranslation} from "../../../../../general";

export const CostTransport = ({categorySettings}) => {
    const {categories} = useProductAttributes() || {};
    const {currencySymbol} = useTranslation();
    const intl = useIntl();

    if (!categories || categories.length === 0 || !categorySettings) {
        return null;
    }

    const renderDeliveryCost = () => {
        if (typeof categorySettings !== 'object') {
            return null;
        }

        for (const category of categories) {
            const categoryId = category.id.toString();
            if (Object.prototype.hasOwnProperty.call(categorySettings, categoryId)) {
                const {shipping_value, punere_in_functiune} = categorySettings[categoryId];
                const setupText = punere_in_functiune
                    ? intl.formatMessage({ id: 'shipping_install' })
                    : '';
                
                return (
                    <p className={'react-css font-bold text-left text-black-friday-btn font-nunito text-xl'}>
                        <FormattedMessage
                            id="shipping_cost"
                            values={{
                                setup: setupText,
                                value: shipping_value,
                                currency: currencySymbol
                            }}
                        />
                    </p>
                );
            }
        }
        return null;
    };

    return (
        <div className={'react-css flex flex-col items-left'}>
            {renderDeliveryCost()}
        </div>
    );
};
